import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import useApiFunction from "../../api/useApiFunction";
import valueContext from "../../customHook/useContext";

function Dashboard() {
  const navigate = useNavigate();
  const location = useLocation();
  const { urlToken } = useParams();
  const { joinMemberToken, splitToken, crypt, setMemberCore } =
    useContext(valueContext);
  let token = "";

  const { formDataFunc } = useApiFunction();
  const [data, setData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const getData = async () => {
    setIsLoading(true);
    const res = await formDataFunc(
      `member/get_member`,
      JSON.stringify({}),
      "POST",
      token
    );
    if (res.status) {
      setData(res.msg);
      setMemberCore(res.msg.core);
    } else if (
      res.error &&
      (res.error === "ERROR_TOKEN_INVALID0" ||
        res.error === "ERROR_TOKEN_INVALID1" ||
        res.error === "user not registered" ||
        res.error === "ERROR_TOKEN_INVALID2" ||
        res.error === "ERROR_TOKEN_INVALID3" ||
        res.error === "unauthorized" ||
        res.error === "Your session has expierd Please login again 1" ||
        res.error === "Your session has expierd Please login again 2")
    ) {
      window.localStorage.removeItem("A_");
      window.localStorage.removeItem("B_");
      window.localStorage.removeItem("C_");
      navigate("/login");
    } else if (res.error) {
      toast.warning(res.error, { autoClose: 2000 });
    } else {
      toast.warning(res.msg);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (!urlToken) {
      token = joinMemberToken();
      getData();
    } else {
      token = splitToken(urlToken);
      const encrypted_textA = crypt("salt", token.textA);
      const encrypted_textB = crypt("salt", token.textB);
      const encrypted_textC = crypt("salt", token.textC);
      window.localStorage.setItem("A_", encrypted_textA);
      window.localStorage.setItem("B_", encrypted_textB);
      window.localStorage.setItem("C_", encrypted_textC);
      token = joinMemberToken();

      navigate("/");
    }
  }, [urlToken]);
  useEffect(() => {
    if (location?.state?.msg) {
      toast.success(location.state.msg, { autoClose: 2000 });
    }
  }, [location]);
  return (
    <>
      {data ? (
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              <div className="title-ref">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0 font-size-18">Dashboard</h4>
                </div>
              </div>

              <div className="row" style={{ justifyContent: "center" }}>
                <div className="col-md-6">
                  <div className="row">
                    <div className="col-xl-12">
                      <div className="card profile-section overflow-hidden">
                        <div className="bg-soft">
                          <div className="row m-0">
                            <div
                              className="col-md-12 user-profile"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <div className="p-3">
                                <h5 className="">Welcome T-Life Coin !</h5>
                                <p>
                                  User Name :{" "}
                                  <span style={{ color: "gray" }}>
                                    {data?.userName ? data.userName : "-"}
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card-body pt-0">
                          <div className="row">
                            <div className="col-sm-12 center-div">
                              <div className="avatar-md profile-user-wid mb-4">
                                <img
                                  src="assets/images/users/userImg.png"
                                  alt=""
                                  className="img-thumbnail rounded-circle"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="row" style={{ margin: "17px 0px" }}>
                            <div className="col-sm-3 center-div">
                              <div className="pt-4 user-pro">
                                <h5 className="text-truncate">
                                  {data?.name ? data.name : "-"}
                                </h5>
                                <p className="text-muted mb-0 text-truncate">
                                  T-Life ID :{" "}
                                  <span
                                    style={{ color: "gray", fontSize: "16px" }}
                                  >
                                    {" "}
                                    {data?.twlUserName
                                      ? data.twlUserName
                                      : "---"}{" "}
                                  </span>
                                </p>
                                <p className="text-muted mb-0 text-truncate">
                                  Hold Token :{" "}
                                  <span
                                    style={{ color: "gray", fontSize: "16px" }}
                                  >
                                    {" "}
                                    {data?.stack_wallet
                                      ? data.stack_wallet
                                      : "0.00"}{" "}
                                    T-life
                                  </span>
                                </p>
                                <p className="text-muted mb-0 text-truncate">
                                  Coin Incentive :{" "}
                                  <span
                                    style={{ color: "gray", fontSize: "16px" }}
                                  >
                                    {" "}
                                    {data?.core_incentive
                                      ? data.core_incentive
                                      : "0.00"}{" "}
                                    T-life
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {data.core === 1 ? (
                  <>
                    <div className="col-md-3">
                      <div className="row">
                        <div className="col-sm-12 mb-3">
                          <div className="a-box">
                            <div className="img-container">
                              <div className="img-inner">
                                <div className="inner-skew">
                                  <img src="/assets/images/a.png" width="100" />
                                </div>
                              </div>
                            </div>
                            <div className="text-container">
                              <h1 className="mt-4">CORE</h1>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-12">
                          <div className="card profile-section">
                            <div className="card-body">
                              <div className="d-flex align-items-center mb-3">
                                <div className="me-3">
                                  <span className="info-card">
                                    <i className="bx bx-copy-alt"></i>
                                  </span>
                                </div>
                                <h5 className="card-info-text">
                                  Total Referral
                                </h5>
                              </div>
                              <div className="card-info-amount mt-4">
                                <h4>
                                  {data.no_of_direct}
                                  {/* <i className="mdi mdi-chevron-up ms-1 text-success"></i> */}
                                </h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="col-md-3">
                      <div className="row">
                        <div className="col-sm-12 mb-3">
                          <div className="a-box">
                            <div className="img-container">
                              <div className="img-inner">
                                <div className="inner-skew">
                                  <img src="/assets/images/b.png" width="100" />
                                </div>
                              </div>
                            </div>
                            <div className="text-container">
                              <h1 className="mt-4">CORE</h1>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
          <ToastContainer />
        </div>
      ) : (
        <h1>Loading</h1>
      )}
    </>
  );
}

export default Dashboard;
